<script>
import Vue from 'vue';
import "keen-slider/keen-slider.min.css";
import KeenSlider from "keen-slider";
window.FontFaceObserver = require('fontfaceobserver');

export default {
    name: "banner",
    data() {
        return {
            slider: null,
            pause: false,
            interval: null,
            current: 1,
        };
    },
    computed: {
        dots() {
            return this.slider ? [...Array(this.slider.track.details.slidesLength).keys()] : [];
        }
    },
    methods: {
        setPause(active) {
            this.pause = active;
            this.setInterval();
        },

        resetInterval() {
            clearInterval(this.interval);
        },

        setInterval() {
            let _self = this;
            this.resetInterval();
            this.interval = setInterval(() => {
                if (!_self.pause) {
                    _self.next();
                }
            }, 5000);
        },

        setFontSizes: function() {
            let _self = this;

            let texts = _self.$el.getElementsByClassName('banner-fit_text');
            let min_font_size = 14;

            for (let i = 0; i < texts.length; i++) {
                let text = texts[i];
                text.style.removeProperty('font-size');
                let font_size = window.getComputedStyle(text, null).getPropertyValue('font-size');
                font_size = parseInt(font_size);

                // Bump the font size down until the text fits in the container
                while (font_size >= min_font_size && (text.scrollWidth > text.clientWidth)) {
                    font_size--;
                    text.style.fontSize = font_size+'px';
                }
            }
        },

		next: function() {
			this.slider.next();
		},
		prev: function() {
			this.slider.prev();
		},
		goto: function(i) {
			this.slider.moveToIdx(i);
		},
    },


    mounted() {
        let _self = this;

        if (_self.$el.getElementsByClassName('banner').length > 1) {
            _self.slider = new KeenSlider(_self.$el, {
                loop: true,
                defaultAnimation: {
                    duration: 1000,
                },
                selector: '.banner',
                dragStarted: () => {
                    _self.setPause(true);
                },
                dragEnded: () => {
                    _self.setPause(false);
                },
                slideChanged: s => {
                    this.current = s.track.details.rel;
                }
            });

            _self.$el.addEventListener('mouseover', function(e) {
                 _self.setPause(true);
             });

            _self.$el.addEventListener('mouseout', function(e) {
                 _self.setPause(false);
             });

            _self.setInterval();
        }


		var font1 = new FontFaceObserver('Jost', {
			weight: 400,
		});
		var font2 = new FontFaceObserver('Jost', {
			weight: 600,
		});
		var font3 = new FontFaceObserver('Jost', {
			weight: 700,
		});
		var font4 = new FontFaceObserver('Jost', {
			weight: 800,
		});
        let timeout = 10000;

        Promise.all([
			font1.load(null, timeout),
			font2.load(null, timeout),
			font3.load(null, timeout),
			font4.load(null, timeout),
        ]).then(function () {
            _self.setFontSizes();
        }, function() {
            // Failed to load fonts. Do it anyway.
            _self.setFontSizes();
        });


        window.addEventListener("resize", function() {
            _self.setFontSizes();
        });
    },


    beforeDestroy() {
        if (this.slider) this.slider.destroy();
    }
};

</script>